import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React from "react";
 const Item2Modal = ({direccion, i, desvinculedDirection}) => {
    let {alias, codCiudad, codDepartamento} = direccion;

    const handleDesvinculedDirection = () => {
        desvinculedDirection({direccion: direccion});
    }

    return (
        <tr key={direccion._id} >
            <th scope="row">{i + 1}</th>
            <td className="text-center">{alias}</td>
            <td className="text-center">{codCiudad}</td>
            <td className="text-center">{codDepartamento}</td>
            <td className="text-center">
                <OverlayTrigger placement="top"
                                overlay={<Tooltip id="tooltip-top">Desvincular Direccion</Tooltip>}>
                    <button type="button" 
                            className="btn btn-sm btn-danger"
                            onClick={handleDesvinculedDirection}>
                        <i className="bi bi-trash"/>
                    </button>
                </OverlayTrigger>
            </td>
        </tr>
    );
}
export default Item2Modal;
